import HomeHeroBGHolSrc from "../assets/img/hol/home-hero-1000.jpg";
import NuffieldGymImg from "../assets/img/health-store/Nuffield-gym-offer_955x875.jpg";
import NuffieldGymImgMobile from "../assets/img/health-store/Nuffield-gym-offer_580x400.jpg";
import React from "react";
import { Urls } from "../constants/UrlConstants";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { RebrandHelper } from "../helpers/brand/RebrandHelper";
import HussleGymOfferImg from "../assets/img/health-store/Hussle_1583_955x875.jpg";
import HussleGymOfferImgmob from "../assets/img/health-store/Hussle_1583_580x400.jpg";
import Amazonofferimage from "../assets/img/health-store/Amazonofferimage_730x490.png";
import ReferFrndNewOfferImg from "../assets/img/health-store/Refer_A_Friend_Scheme_955x660.jpg";
import ReferFrndNewOfferImglarge from "../assets/img/health-store/Refer-a-friend-picture_955x660.jpg";
import ReferFrndNewOfferImgmob from "../assets/img/health-store/Refer-a-friend-picture_480x270.jpg";


const HealthStore = {
  HelpSet: [
    {
      Question: "Is AXA ActivePlus included in my membership?",
      Answer: {
        Any: (
          <p>
            Yes, AXA ActivePlus is available to all{" "}
            {RebrandHelper.getAxaBrandName()} members, offering you exclusive
            discounts across the site. To access these, simply log in/register
            on the site with your {RebrandHelper.getAxaBrandName()} membership
            number and all prices will be automatically updated.
          </p>
        ),
        HOL: (
          <p>
            Yes, AXA ActivePlus is available to all Health-on-Line members,
            offering you exclusive discounts across the site. To access these,
            simply log in/register on the site with your Health-on-Line
            membership number and all prices will be automatically updated.
          </p>
        )
      }
    },
    {
      Question: "How do I access offers on gym membership?",
      Answer: {
        Any: (
          <React.Fragment>
            <p>
              You can purchase the discounted PureGym membership via AXA
              ActivePlus, our online health and wellbeing store. You'll need to
              create an account on the AXA ActivePlus site and add your{" "}
              {RebrandHelper.getAxaBrandName()} membership number to it. Once
              the account is set up, you’ll need to log into your account and
              when you add a PureGym membership to your basket the discount will
              automatically be applied.
            </p>
            <p>
              To receive your PureGym membership discount,{" "}
              <a
                className={layoutStyle.anchorDecorationUnderline}
                href={Urls.ActivePlusBase}
                rel="noopener"
                target="_blank"
              >
                go to AXA ActivePlus
              </a>
            </p>
            <p>
              Terms and conditions apply;{" "}
              <a
                className={layoutStyle.anchorDecorationUnderline}
                href={Urls.ActivePlusPuregymTerms}
                rel="noopener noreferrer"
                target="_blank"
              >
                click here for full information.
              </a>
            </p>
          </React.Fragment>
        ),
        HOL: (
          <React.Fragment>
            <p>
              You can purchase the discounted PureGym membership via AXA
              ActivePlus, our online health and wellbeing store. You'll need to
              create an account on the AXA ActivePlus site and add your
              Health-on-Line membership number to it. Once the account is set
              up, you’ll need to log into your account and when you add a
              PureGym membership to your basket the discount will automatically
              be applied.
            </p>
            <p>
              To receive your PureGym membership discount,{" "}
              <a
                className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                href={Urls.ActivePlusBase}
                rel="noopener"
                target="_blank"
              >
                go to AXA ActivePlus
              </a>
            </p>
            <p>
              Terms and conditions apply;{" "}
              <a
                className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                href={Urls.ActivePlusHOLPuregymTerms}
                rel="noopener noreferrer"
                target="_blank"
              >
                click here for full information.
              </a>
            </p>
          </React.Fragment>
        )
      }
    },
    {
      Question: "What is on offer to help me get healthier?",
      Answer: (
        <React.Fragment>
          <p>
            With so much innovation and change in health, it’s hard for many of
            us to keep up. AXA ActivePlus is designed to act as a guide to good
            health – bringing the latest innovation products to our members...
            and beyond.
          </p>
          <p>
            AXA ActivePlus offers over 2000 products, ranging from wearable
            technology and gym memberships to experience days and supplements.
            With exclusive member discount across the whole site, we help our
            members to achieve good health through smarter products.
          </p>
        </React.Fragment>
      )
    }
  ],
  Hero: {
    HomeHeroBGSrc: {
      Any: "#070E40",
      HOL: HomeHeroBGHolSrc
    },
    HomeHeroBGSrcTablet: {
      Any: "#070E40",
      HOL: HomeHeroBGHolSrc
    },
    HomeHeroBGSrcMobile: {
      Any: "#070E40",
      HOL: HomeHeroBGHolSrc
    },
    Heading: {
      Any: "Welcome to your member offers",
      HOL: "Welcome to your customer offers"
    },
    Description: {
      Any: (
        <React.Fragment>
          <p>
            They're part and parcel of your AXA Health membership.
          </p>
          <p>
            Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment.
          </p>
        </React.Fragment>
      ),
      LargeCorporate: (
        <React.Fragment>
          <p>
            They're part and parcel of your AXA Health membership.
          </p>
          <p>
            Keep fit for less with our special gym offer.
          </p>
        </React.Fragment>
      )
    }
  },
  Cards: {
    IconSrc: NuffieldGymImg,
    IconSrcMobile: NuffieldGymImgMobile,
    Heading: "Up to 40% off at Nuffield Health Gyms",
    Description: (
      <React.Fragment>
        All AXA Health members can enjoy 40% discount off monthly individual gym membership at 100+ Nuffield Health Fitness and Wellbeing centres.{" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.NuffieldGymTermsAndCondition}
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms and conditions apply.
        </a>
      </React.Fragment>
    ),
    LinkText: "FIND OUT MORE",
    LinkTo: Urls.NuffieldGym,
    IsNuffieldGym: true
  },
  HussleGymoffer : {
    IconSrc: HussleGymOfferImg,
    IconSrcMobile: HussleGymOfferImgmob,
    Heading: "Get 40% off a Hussle Monthly+ pass",  
    Description: (
      <React.Fragment>
        Hussle’s Monthly+ pass gives you unlimited access to gyms, pools and spas, across thousands of locations
        on one simple monthly membership, with zero contracts. You also get access to digital health app Yogaia.{" "}
        <br/>
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.HussleGymTermsAndCondition}
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms and conditions apply.
        </a>
      </React.Fragment>
    ),
    LinkText: "FIND OUT MORE",
    LinkTo: Urls.HussleGym,
    IsNuffieldGym: true
  },  
  Amazonoffer: {
    IconSrc: Amazonofferimage,
    IconSrcMobile: Amazonofferimage,
    Heading: "Earn a £100 gift card reward",
    Description: (
      <React.Fragment>
        Make the most of our small business referral reward programme.
        <br />
        <br />
        Both you and your business contacts could get a £100 gift card when you refer them to us. Once they take out a small business healthcare plan, you'll both get a choice of either a: £100 Amazon gift card, £100 M&S gift card or a £100 John Lewis gift card.
        <br />
      </React.Fragment>
    ),
    LinkText: "How to refer another SME",
    LinkTo: Urls.HussleGym,
    IsNuffieldGym: true
  },
  MoreOfferSection: {
    Heading: "What else do we offer?",
    Headingoffer: "How to refer another SME", 
    RefFrnd:{
      IconSrc: ReferFrndNewOfferImglarge,
      IconSrcMobile: ReferFrndNewOfferImgmob,
      Heading: "Refer a friend scheme",
      Description: (
        <React.Fragment>
          Refer a friend to AXA Health and you could both get rewarded. You’ll get to choose from Amazon or M&S e-gift card, National Trust Joint membership, or Bluecrest health MOT, to say thanks. Terms and conditions apply.        <br/>        
        </React.Fragment>
      ),
      LinkText: "FIND OUT MORE",
      LinkTo: Urls.ReferAFriendScheme,
      IsNuffieldGym: true
    },
    RefSubHeading: "Refer a friend scheme",
    RefDescription:
      "You and a friend could get a £100 M&S e-gift card when you refer them to AXA Health.",
    RefPhone: " ",
    RefTerms: (
      <React.Fragment>
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.ReferAFriendScheme}
          rel="noopener noreferrer"
          target="_blank"
        >
          Find out more here 
        </a>{" "}
        <br></br>
        <img src={ReferFrndNewOfferImg} alt="ReferFrndNewOfferImg" style={{maxWidth:"100%",height: "auto"}}/>
      </React.Fragment>
    ),
    OffSubHeading: {
      Any: "25% off Circle Health Group and Nuffield health assessments"
    },
    OffDescription: {
      Any:
        "Get the full picture on your health now, including lifestyle factors such as sleep, stress and nutrition. Get practical guidance on how to improve your health in the future."
    },
    OffDetails: {
      Any: (
        <React.Fragment>
          <p>
            <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={Urls.ActivePlusSMEHealth}
              rel="noopener noreferrer"
              target="_blank"
            >
              More information
            </a>{" "}
            for health assessments
          </p>
        </React.Fragment>
      )
    },
    AFWSubHeading: "AXA Fitness works",
    AFWDescription:
      "AXA Fitness Works provides discounted gym membership at prestigious health clubs across the UK. With UK wide coverage, you can receive specially negotiated rates at Nuffield Health, Better Gyms, Freedom Leisure and British Military Fitness.",
    AFWDetails: (
      <React.Fragment>
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.ActivePlusFitness}
          rel="noopener noreferrer"
          target="_blank"
        >
          Explore gym offers
        </a>{" "}
        for AXA Fitness works
      </React.Fragment>
    ),    
    CustomerReferralSubHeading: "How to refer another SME",
    ButtonLabel: "Get Started ➔",
    AmazonDescription: (<React.Fragment>
      Key Terms and Conditions: This offer is open to existing members referring a new customer who goes on to purchase a small business healthcare plan with AXA Health. If eligible, gift cards will be sent to you and your contact, within 70 days of your contact's purchase as long as you are both still members.
    </React.Fragment>),
    CustomerReferralDescription: (
      <React.Fragment>
        It’s easy to let your contacts know about our offer, so they can find out if our small business healthcare cover could be right for their businesses too. Simply create your unique link and send it on to anyone that you think may be interested. And if they buy cover with us, you’ll both get a choice of either a: £100 Amazon gift card, £100 M&S gift card or a £100 John Lewis gift card. There's no limit to the number of business contacts you can refer.
        <span><p>See T&Cs below.</p></span>
        Start earning your rewards now or just set up your unique link to send when you’re ready.
      </React.Fragment>
    ),
    AmazonReferABusinessCondition: (
      <React.Fragment>
          <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={Urls.ReferABusiness}
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Please click here for full terms and conditions for referring another SME"
          >
            Please click here for full terms and conditions.
          </a>
      </React.Fragment>
    )
  }
};

export default HealthStore;